(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('AddToPortfolioDialogController',AddToPortfolioDialogController);

    AddToPortfolioDialogController.$inject = ['$stateParams','$scope', '$uibModalInstance', 'AlertMasterService','companyName','companyCode','controllerModule','parentAccess','AlertService','$controller','$http','CompanyProfileService','$timeout','$window'];

    function AddToPortfolioDialogController ($stateParams,$scope,$uibModalInstance,AlertMasterService,companyName,companyCode,controllerModule,parentAccess,AlertService,$controller,$http,CompanyProfileService,$timeout,$window) {
        var vm = this;       
        vm.clear = clear;
         vm.alertActionFlag = 'Y';
        $scope.companyCode = companyCode;
        $scope.companyName = companyName;
        
        $scope.selectedPortfolio={};
        $scope.existPortfolios=[];
        
        //$scope.uniquePortfolioName="abc";
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

		        $scope.addToPortfolio = function() {
		        	
		        	if('Y' == $scope.selectedPortfolio.isAlertSet){
		        		$('#editPortfolioRemoveAlertModal').modal('show');
		        	}else{
		        		$scope.addToPortfolioWithConfirmation(false);
		        	}
			

		}

$scope.addToPortfolioWithConfirmation = function(addRemoveAlert){
	$('#editPortfolioRemoveAlertModal').modal('hide');
	$scope.selectedPortfolio.addRemoveAlert = addRemoveAlert;
	if ($window
			.confirm("Are you sure you want to Add  company  in  this "
					+ $scope.selectedPortfolio.name + "  Portfolio ?")) {

		// add portfolio
		$scope.selectedPortfolio.companyCode = $scope.companyCode;
		CompanyProfileService
				.addCompanyInExistingPortfolio($scope.selectedPortfolio)
				.then(
						function(result) {
								
							
							if (result.isSuccess == 'true') {
								$scope.issuccess = true;
								$scope.error = false;
								$scope.successMessages = result.message;
								if(addRemoveAlert){
									
									if (controllerModule == 'companyProfile') {
										parentAccess.setStatus = true;
										parentAccess.alertAction = 'Remove Alert';
										parentAccess.companyAlertFlag = false;
									}else if (controllerModule == 'RatingListController'
										|| controllerModule == 'AdvanceSearchController') {
	
										parentAccess.setStatus = true;
									}
								}
								
							} else {
								$scope.error = true;
								$scope.issuccess = false;
								$scope.errorMessages = result.message;
							}
								
							$timeout(function() {
								$uibModalInstance.dismiss('cancel');
							}, 2000);
						},
						function(response, status, headers, config) {
							$scope.error = true;
							$scope.errorMessage = "Error occured while adding Portfolio Alert"
							$uibModalInstance.dismiss('cancel');
						});

	

	} else {
		$uibModalInstance.dismiss('cancel');

	}
}
        

  $scope.existingPortFolioList = function() {

			CompanyProfileService
					.getExistingPortFoliosDetailsByUser(companyCode)
					.then(
							function(data) {
								$scope.existPortfolios=data;
 							},
							function(errordata) {
								$scope.error = true;
								$scope.errorMessages = "Something went wrong, please try again in some time. If the problem persists, please contact Administrator.";
								$timeout(function() {

									$scope.error = false;
									$scope.errorMessage = "";

								}, 2000);
							});

		}
  $scope.existingPortFolioList(); 
    }
})();
